import { render } from "./HeadlessView.vue?vue&type=template&id=10f65b1c&scoped=true"
import script from "./HeadlessView.vue?vue&type=script&lang=js"
export * from "./HeadlessView.vue?vue&type=script&lang=js"

import "./HeadlessView.vue?vue&type=style&index=0&id=10f65b1c&scoped=true&lang=css"

import exportComponent from "/github/workspace/src/mealplanner-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f65b1c"]])

export default __exports__